enum Envrionments {
  SUPERGASBRAS = "supergasbras",
}

export default Envrionments;
